import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Modal,
    message
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DollarCircleOutlined, PlusOutlined, UploadOutlined} from '@ant-design/icons'
import {
    PaperClipOutlined,
    LinkOutlined,
    SendOutlined,
    SearchOutlined,
    ReloadOutlined,
    DownloadOutlined
} from '@ant-design/icons'
import moment from 'moment';
import View from './view.js'
import Cuijiao from '../public/cuijiao'
import Edit from "../public/jf_edit";
import Jiaofei from "../public/jf_jiaofei";
import Remark from "../public/remark";


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {}, oldcondition: {}, list: [], tableloading: false, selectedRowKeys: [], count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentWillMount() {
        this.props.GET_REFRESH(this.getdata)
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        this.props.NAV_CHANGE('/jf_zlf', ['首页', '缴费管理', '制冷费'])
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        // console.log(subtype)
        // return
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.type = 5
        fetch('/Pay/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.datalist,
                    status_react: data.status_react ? data.status_react : [],
                    yq_react: data.yq_react ? data.yq_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    delSel() {
        let that = this
        fetch('/Pay/delall', {
            method: "POST", body: JSON.stringify({
                'id': this.state.selectedRowKeys,
                type: 5,
            })
        })
            .then(res => res.json())
            .then(data => {
                //
                this.pagechange(1, this.state.oldcondition.pagesize)
                that.setState({
                    selectedRowKeys: []
                })
            })
    }

    AddZl() {
        let that = this
        fetch('/Pay/AddZl', {
            method: "POST", body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(data => {
                //
                that.getdata()
                if (data.status == 1) {
                    message.success(data.msg)
                } else {
                    message.error(data.msg)
                }
            })
    }

    reset() {
        let that = this
        that.setState({
            newcondition: {}, oldcondition: {},
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    download(type) {
        // type==1 下载选中部分
        let that = this
        that.setState({
            downloading: true
        })
        var arr = Object.assign({}, this.state.oldcondition, {})
        if (type == 1) {
            arr = {
                id: that.state.selectedRowKeys
            }
        }
        arr.download = 1
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        arr.type = 5
        fetch('/Pay/index', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 0) {
                    message.error(data.msg);
                    return
                }

                that.setState({
                    downloading: false
                })
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = data.url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                } catch (e) {
                    alert("下载异常！");
                }
            })
    }

    render() {
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'company_name',
                key: 'company_name',
                fixed: 'left',
                width: 200,
                render: (row, record) => {
                    return (<>
                        <div>{row}</div>
                        {record.aliasname ? <div style={{color: 'grey'}}>曾用名：{record.aliasname}</div> : null}
                    </>)
                },
            }, {
                title: '合同编号',
                dataIndex: 'ref',
                key: 'ref',
                width: 200,
            }, {
                title: '合同状态',
                dataIndex: 'contract_status_text',
                key: 'contract_status_text',
                width: 100,
                render: (row, record) => {
                    return (<>
                        {record.contract_status == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.contract_status == 2 && <Tag color={'red'}>{row}</Tag>}
                        {record.contract_status == 3 && <Tag color={'grey'}>{row}</Tag>}
                    </>)
                },
            }, {
                title: '年度',
                dataIndex: 'year',
                key: 'year',
                width: 200,
            }, {
                title: '年度应收制冷费',
                dataIndex: 'num',
                key: 'num',
                width: 180,
            }, {
                title: '制冷状态',
                dataIndex: 'status2_text',
                key: 'status2_text',
                width: 100,
                render: (row, record) => {
                    return (<>
                        {record.status2 == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.status2 == 0 && <Tag color={'red'}>{row}</Tag>}
                    </>)
                },
            }, {
                title: '缴费金额',
                dataIndex: 'true_num',
                key: 'true_num',
                width: 150,
            }, {
                title: '缴费时间',
                dataIndex: 'paytime',
                key: 'paytime',
                width: 150,
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                width: 150,
            }, {
                title: '房间号',
                dataIndex: 'room',
                key: 'room',
                width: 150,
            }, {
                title: '租赁面积',
                dataIndex: 'area',
                key: 'area',
                width: 150,
            }, {
                title: '租赁时间',
                dataIndex: 'zltime',
                key: 'zltime',
                width: 200,
            }, {
                title: '租赁时长',
                dataIndex: 'duration',
                key: 'duration',
                width: 120,
            }, {
                title: '退租时间',
                dataIndex: 'zletime',
                key: 'zletime',
                width: 120,
            }, {
                title: '备注信息',
                dataIndex: 'remark',
                key: 'remark',
                width: 120,
                fixed: "right",
                render: (row, record) => {
                    return (<>
                        {!row ? <span style={{color: '#aaa'}}>无</span>
                            :
                            <a onClick={() => Modal.info({
                                width: 1200,
                                bodyStyle: {padding: 15},
                                closable: true,
                                maskClosable: true,
                                icon: null,
                                okButtonProps: {style: {display: 'none'}},
                                title: <div>&nbsp;</div>,
                                content: <Remark id={record.id} type={5} cate={2}/>,
                            })}>查看</a>
                        }
                    </>)
                },
            }, {
                title: '缴费状态',
                dataIndex: 'status_text',
                key: 'status_text',
                width: 180,
                fixed: "right",
                render: (row, record) => {
                    return (<>
                        {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.status == 2 && <Tag color={'blue'}>{row}</Tag>}
                        {record.status == 3 && <Tag color={'red'}>{row}</Tag>}
                        {record.status == 4 && <Tag color={'orange'}>{row}</Tag>}
                        {record.status == 5 && <Tag color={'grey'}>{row}</Tag>}
                        {record.jfroom ? <div>{record.jfroom}</div> : null}
                    </>)
                },
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 200,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <View id={record.id} refresh={this.getdata.bind(this)}/>
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('305') ?
                                <>
                                    {record.status == 1 ? null :
                                        <Cuijiao company_id={record.company_id}/>}
                                    <Edit type={5} id={record.id} timename={"制冷时间"}
                                          refresh={this.getdata.bind(this)}/>
                                    {record.status == 1 ? null :
                                        <Jiaofei type={5} id={record.id} refresh={this.getdata.bind(this)}/>}
                                </>
                                : null) : null}
                        </Space>
                    </>)
                },
            },]
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <Row justify="space-between" align="top" style={{marginBottom: 15}}>
                <Space wrap>
                    <Input className="input" placeholder="企业名称/房间号/合同编号"
                           style={{width: 200}}
                           value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                           onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                    <Select placeholder="所属园区"
                            style={{width: 120}}
                            value={this.state.newcondition.yq_id ? this.state.newcondition.yq_id : null}
                            onChange={this.onSelChange.bind(this, 'yq_id')} allowClear>
                        {this.arrsel(this.state.yq_react)}
                    </Select>
                    <Select placeholder="缴费状态"
                            style={{width: 120}}
                            value={this.state.newcondition.status ? this.state.newcondition.status : null}
                            onChange={this.onSelChange.bind(this, 'status')} allowClear showSearch
                            optionFilterProp="children">
                        {this.arrsel(this.state.status_react)}
                    </Select>
                    <RangePicker allowEmpty={[true, true]} onChange={this.onRangeChange.bind(this, 'time')}
                                 value={[(this.state.newcondition.time1 ? moment(this.state.newcondition.time1) : null), (this.state.newcondition.time2 ? moment(this.state.newcondition.time2) : null)]}
                                 placeholder={['时间范围', '时间范围']}/>
                    <Button type="primary" icon={<SearchOutlined/>}
                            onClick={this.getdata.bind(this, 1)}>查询</Button>
                    <Button type="primary" icon={<ReloadOutlined/>} className='huise'
                            onClick={this.reset.bind(this)}>重置</Button>
                    {store.getState().data.info.lmqx_tj ? (store.getState().data.info.lmqx_tj.includes('305') ?
                        // <Button type="primary" icon={<UploadOutlined/>}>导入</Button>
                        <Edit type={5} refresh={this.getdata.bind(this)}/>
                        : null) : null}
                    {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('305') ?
                        <Popconfirm
                            title="确认发起制冷费?"
                            onConfirm={() => this.AddZl()}
                            okText="确认"
                            cancelText="取消"
                        >
                            <Button type="primary" icon={<DollarCircleOutlined/>}>发起制冷费</Button>
                        </Popconfirm>
                        : null) : null}
                    {/*{store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('305') ?
                        <Button type="primary" icon={<DownloadOutlined/>}>导出</Button>
                        : null) : null}*/}
                </Space>
            </Row>
            <Table
                bordered
                columns={columns}
                dataSource={this.state.list}
                pagination={false}
                loading={tableloading}
                rowSelection={rowSelection}
                className='table'
                scroll={{x: 2800}}
                style={{marginBottom: 20}}
            />
            <Row justify={'space-between'}>
                <div className='l'>
                    <Space wrap>
                        {hasSelected ? <>
                            {store.getState().data.info.lmqx_bj ? (store.getState().data.info.lmqx_bj.includes('305') ?
                                <>
                                    <Popconfirm
                                        title="确认删除?"
                                        onConfirm={() => this.delSel()}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <Button type="primary" danger>删除</Button>
                                    </Popconfirm>
                                </>
                                : null) : null}
                            {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('305') ?
                                <Button type="primary"
                                        onClick={() => this.download(1)}>导出</Button> : null) : null}
                        </> : null}
                        {store.getState().data.info.lmqx_dc ? (store.getState().data.info.lmqx_dc.includes('305') ?
                            <Button type="primary" onClick={() => this.download()}>全部导出</Button>
                            : null) : null}
                    </Space>
                </div>
                <Pagination showQuickJumper
                            current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                            pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                            total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                            showTotal={total => `共 ${total} 条数据`}/>
            </Row>
        </>)
    }
}

export default (props) => <Index {...props} key={props.location.pathname}/>
